import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import Modal from '../ui/Modal';
import { categoryLabel } from './CategoryBadge';
import Select from '../ui/Select';
import Button from '../ui/Button';
import { listWorkflowCategories } from '../../api/workflow';
import { changeCandidateCategory } from '../../api/candidates';
import { pushToast } from '../ui/toastBus';

export default function ChangeCategoryModal({ open, onClose, candidate }) {
  const queryClient = useQueryClient();
  const categoriesQuery = useQuery({ queryKey: ['workflow-categories'], queryFn: listWorkflowCategories, enabled: open });
  const [categoryId, setCategoryId] = useState('');
  const [error, setError] = useState('');

  const mutation = useMutation({
    mutationFn: () => changeCandidateCategory(candidate.id, categoryId),
    onSuccess: () => {
      pushToast({ type: 'success', message: 'Category changed. Steps re-initialized.' });
      queryClient.invalidateQueries({ queryKey: ['candidates', String(candidate.id)] });
      handleClose();
    },
    onError: (err) => setError(err.response?.data?.message || 'Could not change category.'),
  });

  const handleClose = () => {
    setCategoryId('');
    setError('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Change category"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={() => mutation.mutate()} loading={mutation.isPending} disabled={!categoryId}>
            Change category
          </Button>
        </>
      }
    >
      <p className="mb-3 text-sm text-gray-600">
        This re-initializes the candidate's workflow steps for the new category. Currently:{' '}
        <strong>{categoryLabel(candidate.category)}</strong>.
      </p>
      <Select label="New category" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
        <option value="">Select…</option>
        {(categoriesQuery.data || [])
          .filter((c) => c.id !== candidate.category.id)
          .map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
      </Select>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </Modal>
  );
}
